import { ReqX } from "IZOX/STATIC";

/**
   * @typedef {"SignIn" | "ResetPassword" | "Register"} authorizedAction
   * @typedef {"Email" | "SMS" | "App" | "QR"} sendVia
   */

class OTP {

  /**
   * 
   * @param {String} userID 
   * @param {authorizedAction} authorizedAction 
   * @param {sendVia} via 
   * @returns 
   */
  static async Resend(userID, authorizedAction, via = "Email"){
    return await ReqX.SendBE("/CommonAPI/OTP/Resend", {
      userID: userID,
      authorizedAction: authorizedAction,
      via: via
    });
  }

  /**
   * 
   * @param {String} userID 
   * @param {String} requestID 
   * @param {authorizedAction} authorizedAction 
   * @param {String} otp 
   * @returns 
   */
  static async Verify(userID, requestID, authorizedAction, otp){
    return await ReqX.SendBE("/CommonAPI/OTP/Verify", {
      userID: userID,
      requestID: requestID,
      authorizedAction: authorizedAction,
      otp: otp
    });
  }

}

export default OTP;